import { render, staticRenderFns } from "./AffiliateCompanyModal.vue?vue&type=template&id=288c016b&"
import script from "./AffiliateCompanyModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports